import * as io from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';

export class ChatService {
  //private url = 'http://socket1.carbrewer.com:3002';
  private socketUrl = 'http://socket.epiphanex.com:5000';
  private socket;

  constructor() {
    this.socket = io(this.socketUrl, {
      transports: ['websocket'],
    });
    this.socket.on('connect', () => {
      this.socket.emit('new-message', 'portal service connected: chat.service');
    });
  }
  public sendMessage(message) {
    this.socket.emit('new-message', message);
  }
  public getMessages = () => {
    return new Observable((observer) => {
      this.socket.on('new-message', (message) => {
        observer.next(message);
      });
    });
  };
  public getInventoryStatus = () => {
    return new Observable((observer) => {
      this.socket.on('inventory', (data) => {
        observer.next(data);
      });
    });
  };
  public monitorInventoryCounts = () => {
    return new Observable((observer) => {
      this.socket.on('inventory', (data) => {
        observer.next(data);
      });
    });
  };
  public monitorMatchingStatus = () => {
    return new Observable((observer) => {
      this.socket.on('matching', (data) => {
        observer.next(data);
      });
    });
  };
}
